import { Box, Text } from "@chakra-ui/react";

export const ReportInfoCallout = ({ children }) => {
  if (!children) return null;

  return (
    <Box className="reportInfoCallout">
      <span className="reportInfoIcon">i</span>
      <Text as="p">{children}</Text>
    </Box>
  );
};

export const ReportTitleWithInfo = ({ as: Component = "h3", children, description }) => (
  <>
    <Box className="reportTitleWithInfo">
      <Component>{children}</Component>
    </Box>
    <ReportInfoCallout>{description}</ReportInfoCallout>
  </>
);

export const ReportSectionIntro = ({ title, description, children }) => (
  <Box className="reportSectionIntro">
    <ReportTitleWithInfo description={description || children}>{title}</ReportTitleWithInfo>
  </Box>
);

export default ReportTitleWithInfo;
